/** Italienische Flagge als SVG (Emoji-Flaggen werden unter Windows nur als "IT" dargestellt). */
export function ItalianFlag({ className = "h-6 w-9" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 3 2"
      className={`${className} rounded-[3px] shadow-[0_0_0_1px_rgba(255,255,255,0.18),0_2px_8px_rgba(0,0,0,0.5)]`}
      role="img"
      aria-label="Italienische Flagge"
    >
      <rect width="1" height="2" x="0" fill="#009246" />
      <rect width="1" height="2" x="1" fill="#ffffff" />
      <rect width="1" height="2" x="2" fill="#ce2b37" />
    </svg>
  );
}
